import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const rootEl = document.getElementById("root");

// react-snap: hydrate pre-rendered HTML if present, otherwise create fresh root
if (rootEl.hasChildNodes() && rootEl.querySelector('[data-reactroot]')) {
  const root = ReactDOM.hydrateRoot(rootEl,
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  const root = ReactDOM.createRoot(rootEl);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
